export const LABELS_GAP_PX = 4;
export const MIN_CARD_WIDTH = 290;
export const BODY_PADDING = 24;
export const MAX_TAGS_QTY = 3;
